import { QueryKey } from 'constants/reactQuery';

export const episodeReadRecordQueryKey = {
  episodeReadRecord: (contentId: number) => [QueryKey.EpisodeReadRecord, contentId] as const,
  episodeReadPosition: (contentId: number, episodeId: number) =>
    [QueryKey.EpisodeReadPosition, contentId, episodeId] as const,
};
